import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import "./CategoryListing.css";
import VoteButton from "../VoteButton/VoteButton";
import ExpandIcon from "../ExpandIcon/ExpandIcon";

import Placeholder from "../../assets/placeholder.png";
import axios from "axios";
import { setAllVotesForUser } from "../../redux/reducers/UserVoteReducer";

import FirstWinnerBanner from "../../assets/1st-place.svg";
import FirstRunnerUp from "../../assets/2nd-place.svg";
import SecondRunnerUp from "../../assets/3rd-place.svg";
import ThirdRunnerUp from "../../assets/4th-place.svg";
import FourthRunnerUp from "../../assets/5th-place.svg";

import winnerData from "../../data/winner.json";

const CategoryListing = ({
  data,
  isOpen,
  setIsOpen,
  setSelectedCuisine,
  setIsLoggedIn,
  setOverlayPosition,
}) => {
  const stateName = "sa";

  const dispatch = useDispatch();

  const state = useSelector((state) => state.deliciousFilterType);

  const [showList, setShowList] = useState(data);

  const [uniqueCuisinesList, setUniqueCuisinesList] = useState([]);

  const [imageLoadErrors, setImageLoadErrors] = useState(
    new Array(data?.length).fill(false)
  );

  const handleImageError = (index) => {
    const updatedErrors = [...imageLoadErrors];
    updatedErrors[index] = true;
    setImageLoadErrors(updatedErrors);
  };

  const calculatePositionFromTop = (index) => {
    const bag = document.getElementById(
      `delicious100-interactive__main_restaurant_tile__${index}`
    );
    if (index >= 0) {
      if (!bag?.offsetTop) {
        setOverlayPosition(0);
      } else setOverlayPosition(bag.offsetTop);
    } else {
      setOverlayPosition(0);
    }
    console.log("Offset position", index, bag?.offsetTop);
  };

  useEffect(() => {
    // Filtering the content shown based on Filters
    const selectedCusinies = state.selectedCuisineFilters;
    const selectedRegions = state.selectedRegionFilters;

    const filteredList = data?.filter((dataObj) => {
      const matchCuisine =
        selectedCusinies?.includes(dataObj.cuisine) ||
        selectedCusinies?.includes("All");

      const matchRegion = Array.isArray(dataObj.region)
        ? dataObj.region.some(
            (region) =>
              selectedRegions?.includes(region) ||
              selectedRegions?.includes("All")
          )
        : selectedRegions?.includes(dataObj.region) ||
          selectedRegions?.includes("All");

      return matchCuisine && matchRegion;
    });

    // console.log("filteredList", filteredList);

    setShowList(filteredList);
  }, [state, data]);

  useEffect(() => {
    // console.log("winnerData", winnerData?.[0]?.sa?.first?.includes(30));
    // Create a Set to store unique cuisines
    const uniqueCuisines = new Set();

    // Iterate through the list and add cuisines to the Set
    showList.forEach((restaurant) => {
      uniqueCuisines.add(restaurant.cuisine);
    });

    // Convert the Set to an array (if needed)
    const uniqueCuisinesArray = Array.from(uniqueCuisines);

    setUniqueCuisinesList(uniqueCuisinesArray);
  }, [showList]);

  const getCookie = (name) => {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(name + "=")) {
        return decodeURIComponent(cookie.substring(name.length + 1));
      }
    }
    return null;
  };

  const addVoteForCategory = async (dataObject) => {
    let rampartToken = getCookie("rampart_token");

    if (!rampartToken) {
      rampartToken = window.DNA_APP_ENV?.["rampart_token"];
    }

    console.log("rampartToken", rampartToken);

    if (!rampartToken) {
      setIsLoggedIn(true);
    }

    const reqBody = {
      rampart_token: rampartToken,
      data: {
        restaurant_id: dataObject?.id,
        restaurant_name: dataObject["restaurant-name"],
        state: "SA",
        cuisine: dataObject?.cuisine,
      },
    };

    const apiUrl =
      "https://tob6kguqgtiahokcjm7nyie4ca0pqhuj.lambda-url.ap-southeast-2.on.aws/";

    // Make the PUT request with a try...catch block
    try {
      const response = await axios.put(apiUrl, reqBody);

      if (response.status === 200) {
        // Do a state update
        const votedItems = response?.data?.body?.items;
        dispatch(setAllVotesForUser(votedItems));
      }
      if (response.status === 403) {
        setIsLoggedIn(true);
      }
    } catch (error) {
      // Handle any errors
      console.error("Delicious100 - Error posting a vote", error);
    }
  };

  return (
    <div className="delicious100-interactive__main_listings">
      {uniqueCuisinesList?.map((cuisineName, index) => {
        return (
          <div
            className="delicious100-interactive__cuisine_category_listing"
            key={cuisineName + " " + index}
          >
            {/* <span className="delicious100-interactive__filters_title">
              {cuisineName}
            </span> */}
            <span className="delicious100-interactive__filters_title">
              {cuisineName}
            </span>
            <ExpandIcon></ExpandIcon>
            <div className="delicious100-interactive__main_restaurant_tile_wrapper">
              {showList &&
                showList
                  ?.filter(
                    (dataObj) =>
                      dataObj.cuisine === cuisineName || cuisineName === "All"
                  )
                  .map((dataObject, index) => (
                    <div
                      className="delicious100-interactive__main_restaurant_tile"
                      id={`delicious100-interactive__main_restaurant_tile__${dataObject.id}`}
                      key={dataObject?.id + " " + index}
                      onClick={() => {
                        // console.log("indexxx", dataObject.id);
                        setIsOpen(!isOpen);
                        setSelectedCuisine(dataObject);
                        calculatePositionFromTop(dataObject.id);
                      }}
                    >
                      <div
                        className="delicious100-interactive__main_image_wrapper"
                        key={dataObject?.id + " " + index}
                      >
                        {winnerData &&
                        winnerData?.[0]?.[`${stateName}`]?.first?.includes(
                          Number.parseInt(dataObject?.id)
                        ) ? (
                          <img
                            key={dataObject?.id + " " + index}
                            className="delicious100-interactive__winner_img"
                            alt={"FirstWinnerBanner"}
                            src={FirstWinnerBanner}
                            onError={() => handleImageError()}
                          ></img>
                        ) : winnerData?.[0]?.[`${stateName}`]?.second?.includes(
                            Number.parseInt(dataObject?.id)
                          ) ? (
                          <img
                            key={dataObject?.id + " " + index}
                            className="delicious100-interactive__runner_up_img"
                            alt={"FirstRunnerUp"}
                            src={FirstRunnerUp}
                            onError={() => handleImageError()}
                          ></img>
                        ) : winnerData?.[0]?.[`${stateName}`]?.third?.includes(
                            Number.parseInt(dataObject?.id)
                          ) ? (
                          <img
                            key={dataObject?.id + " " + index}
                            className="delicious100-interactive__runner_up_img"
                            alt={"SecondRunnerUp"}
                            src={SecondRunnerUp}
                            onError={() => handleImageError()}
                          ></img>
                        ) : winnerData?.[0]?.[`${stateName}`]?.fourth?.includes(
                            Number.parseInt(dataObject?.id)
                          ) ? (
                          <img
                            key={dataObject?.id + " " + index}
                            className="delicious100-interactive__runner_up_img"
                            alt={"ThirdRunnerUp"}
                            src={ThirdRunnerUp}
                            onError={() => handleImageError()}
                          ></img>
                        ) : (
                          <img
                            key={dataObject?.id + " " + index}
                            className="delicious100-interactive__runner_up_img"
                            alt={"FourthRunnerUp"}
                            src={FourthRunnerUp}
                            onError={() => handleImageError()}
                          ></img>
                        )}

                        <img
                          key={dataObject?.id + " cuisine " + index}
                          className="delicious100-interactive__main_image"
                          alt={dataObject["restaurant-name"]}
                          src={
                            "https://d2n6ofw4o746cn.cloudfront.net/interactives/delicious100/sa/restaurant-images/" +
                            dataObject["image-url"]
                          }
                          onError={() => handleImageError()}
                        ></img>
                        {imageLoadErrors.indexOf(index) === true && (
                          <img
                            key={dataObject?.id + " " + index}
                            className="delicious100-interactive__main_image"
                            alt={dataObject["restaurant-name"]}
                            src={Placeholder}
                          ></img>
                        )}

                        {/* <VoteButton
                          voteButtonId={dataObject?.id}
                          onClick={(e) => {
                            e.stopPropagation();

                            addVoteForCategory(dataObject);
                          }}
                        /> */}
                      </div>

                      <div className="delicious100-interactive__main_restaurant_details">
                        <span className="delicious100-interactive__main_restaurant_name">
                          {dataObject["restaurant-name"]}
                        </span>
                        {dataObject &&
                          dataObject["suburb/city"] &&
                          (Array.isArray(dataObject["suburb/city"]) ? (
                            dataObject["suburb/city"].map((suburb, index) => (
                              <span
                                key={index}
                                className="delicious100-interactive__main_restaurant_cuisine"
                              >
                                {`${suburb}${
                                  index !== dataObject["suburb/city"].length - 1
                                    ? ", "
                                    : ""
                                }`}
                              </span>
                            ))
                          ) : (
                            <span className="delicious100-interactive__main_restaurant_cuisine">
                              {`${dataObject["suburb/city"]}`}
                            </span>
                          ))}
                      </div>
                    </div>
                  ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CategoryListing;
